module.exports = __webpack_public_path__ + "static/media/home_img_bottom2.9ffbc529.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/home_img_bottom2.png
// module id = 402
// module chunks = 14